import React from "react";
import {
  AlertBanner,
  AlertBannerContent,
  AlertBannerDescription,
  AlertBannerIndicator,
  AlertBannerTitle,
} from "@commonsku/design-system";

const AutomationEarlyAccessAlert = () => {
  return (
    <AlertBanner status="info">
      <AlertBannerIndicator />
      <AlertBannerContent gap="0">
        <AlertBannerTitle fontWeight="semibold">
          This is an early version of Automations
        </AlertBannerTitle>
        <AlertBannerDescription>
          You can enable or disable the automation and adjust which phases and
          days trigger it. More automation types and configuration options are
          coming soon.
        </AlertBannerDescription>
      </AlertBannerContent>
    </AlertBanner>
  );
};

export default AutomationEarlyAccessAlert;
